import { useContext } from 'react';
import { ConnectivityContext } from './connectivity-service';

export function useConnectivity() {
  return useContext(ConnectivityContext);
}
